<div [formGroup]="formGroup">
    <div formArrayName="animals">
        @if(isMultipleAnimals) {
        <div class="margin-top-10">
            <h1>{{ 'addNewCustomer.animals.title' | translate}}</h1>
            <button mat-raised-button color="primary" (click)="addFormNewAnimal()">
                {{ 'addNewCustomer.button.add' | translate }}
            </button>
        </div>
        }

        @for (animal of animalsFormArray.controls; track animal; let i = $index) {
        <div class="d-flex full-width max-width-inherit form-card overflow-auto" [formGroupName]="i"
            [id]="'animalForm'+i">
            <div class="container-animal">
                <div class="content-row">
                    <mat-form-field appearance="outline">
                        <mat-label>
                            {{'addNewCustomer.input.name.label' | translate}}
                        </mat-label>
                        <input matInput type="text" id="intAnimalName" formControlName="animalName" />
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>
                            {{'addNewCustomer.input.breedingName.label' | translate}}
                        </mat-label>
                        <input matInput type="text" id="intCatteryName" formControlName="catteryName" />
                    </mat-form-field>
                    <mat-form-field appearance="outline" class="mat-form-field">
                        <mat-label>
                            {{ 'addNewCustomer.animalType.dropdown.title' | translate }}
                        </mat-label>
                        <mat-select formControlName="species" id="somSpecies">
                            @for (species of animalTypeNames; track species) {
                            <mat-option [value]="species" [id]="'spnOption' + species">
                                {{ species }}
                            </mat-option>
                            }
                        </mat-select>
                    </mat-form-field>
                    @if (!isMultipleAnimals && this.animal) {
                    <button [color]="this.animal.isActive ? 'accent': ''"
                        [class.button-activate-color]="!this.animal.isActive" class="margin-top-15"
                        (click)="onChangeActiveStatus()" mat-raised-button>
                        {{ (this.animal.isActive ? 'user.dialog.inactivate.button': 'user.dialog.activate.button') |
                        translate}}</button>
                    }


                </div>
                <div class="content-row">
                    <mat-form-field appearance="outline">
                        <mat-label>
                            {{'addNewCustomer.input.breed.label' | translate}}
                        </mat-label>
                        <input matInput type="text" id="intRace" formControlName="race" />
                    </mat-form-field>
                    <mat-form-field appearance="outline">
                        <mat-label>
                            {{'addNewCustomer.input.color.label' | translate}}
                        </mat-label>
                        <input matInput type="text" id="intAnimalColor" formControlName="animalColor" />
                    </mat-form-field>
                    <div class="radio-group">
                        <div class="radio-button-options">
                            {{ 'addNewCustomer.radioButton.sex.label' | translate }} *
                            <mat-radio-group formControlName="sex" class="width-sex-radio-option">
                                <mat-radio-button [disableRipple]="true" [value]="'f'" id="chkSexF">
                                    {{'addNewCustomer.radioButton.sex.option.female.label' | translate}}
                                </mat-radio-button>
                                <mat-radio-button [disableRipple]="true" [value]="'m'" id="chkSexM">
                                    {{'addNewCustomer.radioButton.sex.option.male.label' | translate}}
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                        <div class="radio-button-options">
                            {{ 'addNewCustomer.radioButton.neutered.label' | translate }}
                            <mat-radio-group formControlName="isCastrated">
                                <mat-radio-button [disableRipple]="true" [value]="false">
                                    {{'general.label.no' | translate}}
                                </mat-radio-button>
                                <mat-radio-button [disableRipple]="true" [value]="true">
                                    {{'general.label.yes' | translate }}
                                </mat-radio-button>
                            </mat-radio-group>
                        </div>
                    </div>
                </div>
                <div class="content-row">
                    @if (isMultipleAnimals) {

                    <mat-form-field appearance="outline" class="display-block">
                        <mat-label>{{'addNewCustomer.datePicker.birthDate.label' | translate}}</mat-label>
                        <input matInput id="intBirthDate" mbsc-datepicker [max]="maxBirthDate" [controls]="['date']"
                            formControlName="birthDate" themeVariant="light" theme="material" display="anchored"
                            [touchUi]="true" [cancelText]="'appointment.edit.timepicker.cancel' | translate"
                            [buttons]="['set', 'cancel']" [setText]="'general.label.yes' | translate"
                            dateFormat="DD.MM.YYYY" returnFormat="jsdate" [locale]="localeDatePicker"/>
                        <mat-icon matSuffix>
                            calendar_today
                        </mat-icon>
                    </mat-form-field>

                    <div class="full-width">
                        <mat-form-field appearance="outline" class="display-block full-width">
                            <mat-label>
                                {{'addNewCustomer.input.microchip.label' | translate}}
                            </mat-label>
                            <input matInput formControlName="microChip" />
                        </mat-form-field>
                        @if (animalsFormArray.controls[i]?.get('microChip')?.invalid &&
                        animalsFormArray.controls[i]?.get('microChip')?.dirty) {
                        <div class="error">
                            *{{'addNewCustomer.input.microchip.error' | translate}}
                        </div>
                        }
                    </div>
                    <mat-form-field appearance="outline" class="display-block">
                        <mat-label>{{'addNewCustomer.datePicker.microChipDate.label' | translate}}
                        </mat-label>
                        <input matInput id="intMicroChipDate" mbsc-datepicker [controls]="['date']"
                            formControlName="microChipDate" themeVariant="light" theme="material" display="anchored"
                            [touchUi]="true" [cancelText]="'appointment.edit.timepicker.cancel' | translate"
                            [buttons]="['set', 'cancel']" [setText]="'general.label.yes' | translate"
                            dateFormat="DD.MM.YYYY" returnFormat="jsdate" [locale]="localeDatePicker" />
                        <mat-icon matSuffix>
                            calendar_today
                        </mat-icon>
                    </mat-form-field>

                    }

                </div>
                <!-- Date types -->
                @if(!isMultipleAnimals) {

                <div formArrayName="dates">
                    <div class="margin-top-10 d-flex width-70">
                        <h2>{{ 'customer.newAnimal.date.title' | translate}}</h2>
                        <button mat-raised-button color="primary" id="btnAddNewDate" class="margin-left-auto"
                            [disabled]="this.animal && isFormInputsDisabled" (click)="addFormNewDateType(i)">
                            <mat-icon>add</mat-icon>
                            {{ 'customer.newAnimal.button.addDateType' | translate }}
                        </button>
                    </div>
                    @for (dateType of getAnimalDatesFormArray(i).controls; track dateType; let indexDateType = $index) {
                    <div class="d-flex" [formGroupName]="indexDateType" [id]="'dateForm'+indexDateType">
                        <diana-select-date-type class="width-70" [index]="indexDateType"
                            [formGroup]="convertToFormGroup(dateType)" [dateTypesAvailable]="dateTypesAvailable"
                            [formArrayDateTypes]="getAnimalDatesFormArray(i)">
                        </diana-select-date-type>
                        @if (!isFormInputsDisabled) {
                        <div class="radio-button-options">
                            <button mat-icon-button class="icon-active" [disabled]="this.animal && isFormInputsDisabled"
                                (click)="deleteDateType(i, indexDateType)" [id]="'btnDeleteDateType' + indexDateType">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                        }
                    </div>
                    }
                </div>
                }
                <!-- External numbers -->
                @if (!isMultipleAnimals) {
                <div formArrayName="externalNumbers">
                    <div class="margin-top-10 d-flex width-70">
                        <h2>{{ 'customer.newAnimal.externalNumber.title' | translate}}</h2>
                        <button mat-raised-button class="margin-top-10 margin-left-auto"
                            [disabled]="this.animal && isFormInputsDisabled" color="primary"
                            id="btnAddNewExternalNumber" (click)="addFormNewExternalNumber(i)">
                            <mat-icon>add</mat-icon>
                            {{ 'customer.newAnimal.button.addExternalNumber' | translate }}
                        </button>
                    </div>
                    @for (externalNumber of getAnimalExternalNumbersFormArray(i)?.controls; track externalNumber; let
                    indexExternalNumber = $index) {
                    <div class="d-flex" [formGroupName]="indexExternalNumber" [id]="'dateForm'+indexExternalNumber">
                        <diana-select-external-numbers class="width-70" [formGroup]="convertToFormGroup(externalNumber)"
                            [externalNumbersAvailable]="externalNumbersAvailable" [index]="indexExternalNumber"
                            [formArrayExternalNumbers]="getAnimalExternalNumbersFormArray(i)">
                        </diana-select-external-numbers>
                        @if (!isFormInputsDisabled) {
                        <div class="margin-top-10">
                            <button mat-icon-button class="icon-active" [disabled]="this.animal && isFormInputsDisabled"
                                (click)="deleteExternalNumberType(i, indexExternalNumber)"
                                [id]="'btnDeleteExternalNumber' + indexExternalNumber">
                                <mat-icon>delete</mat-icon>
                            </button>
                        </div>
                        }

                    </div>
                    }
                </div>
                }

            </div>
            @if(isMultipleAnimals) {
            <div class="delete-button">
                <button mat-icon-button class="icon-active" (click)="deleteAnimal(i)" [disabled]="isFormInputsDisabled">
                    <mat-icon>delete</mat-icon>
                </button>
            </div>
            }
        </div>
        }
    </div>
</div>